<template>
  <template v-if="isAuthRoute">
    <router-view />
  </template>
  <UiLayout v-else v-slot="{ toggleNav }">
    <router-view :toggle-nav="toggleNav" />
  </UiLayout>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import UiLayout from '@/components/ui/UiLayout.vue';

const route = useRoute();
// Login view is outside the layout; everything else is wrapped.
const isAuthRoute = computed(() => route.name === 'login');
</script>
